export const environment = {
  production: false,
  // Staging API is on a separate domain from the Cloudflare Pages frontend.
  // Absolute URL required — no dev-server proxy in production-like staging.
  apiUrl: 'https://staging-api.sellersage.in',
  // All admin API calls go through api-gateway (adds auth headers, enforces role=admin)
  adminApiUrl: 'https://staging-api.sellersage.in/api/admin',
};
